import { CSSProperties } from "react";


export interface Styles {
  // Hero Section
  heroSection: CSSProperties;
  heroContent: CSSProperties;
  heroTitle: CSSProperties;
  heroSubtitle: CSSProperties;
  heroDescription: CSSProperties;
  heroImageWrapper: CSSProperties;
  heroImage: CSSProperties;
  highlight: CSSProperties;


  // Features Section
  featuresSection: CSSProperties;
  featureCard: CSSProperties;
  featureIconWrapper: CSSProperties;
  featureIcon: CSSProperties;
  featureTitle: CSSProperties;
  featureText: CSSProperties;


  // Offerings Section
  offeringsSection: CSSProperties;
  offeringCard: CSSProperties;
  offeringDot: CSSProperties;
  offeringTitle: CSSProperties;
  offeringDescription: CSSProperties;


  // Values Section
  valuesSection: CSSProperties;
  valueCard: CSSProperties;
  valueIconWrapper: CSSProperties;
  valueIcon: CSSProperties;
  valueTitle: CSSProperties;
  valueText: CSSProperties;


  // Future Services Section
  futureSection: CSSProperties;
  futureServiceItem: CSSProperties;
  serviceBullet: CSSProperties;
  serviceText: CSSProperties;


  // Profit Section
  profitSection: CSSProperties;
  profitCard: CSSProperties;
  profitIconWrapper: CSSProperties;
  profitIcon: CSSProperties;
  profitText: CSSProperties;


  // CTA Section
  ctaSection: CSSProperties;
  ctaTitle: CSSProperties;
  ctaText: CSSProperties;
  ctaClosing: CSSProperties;


  // Common
  sectionTitle: CSSProperties;
  sectionTitleLeft: CSSProperties;
  sectionSubtitle: CSSProperties;


  // Legacy
  text: CSSProperties;
  imgWrap: CSSProperties;
  img: CSSProperties;
  contentWrap: CSSProperties;
  title: CSSProperties;
  info: CSSProperties;
  careerImgWrap: CSSProperties;
  subTitle: CSSProperties;
  sectionContainer: CSSProperties;
  paragraph: CSSProperties;
  listItem: CSSProperties;
  boldText: CSSProperties;
}


const styles: Styles = {
  // Hero Section
  heroSection: {
    paddingTop: 80,
    paddingBottom: 80,
    background: "linear-gradient(135deg, #075CF6 0%, #0645ca 100%)",
    color: "white",
  },
  heroContent: {
    textAlign: "left",
    paddingRight: 40,
  },
  heroTitle: {
    fontFamily: "var(--primary-font-bold)",
    fontSize: 42,
    fontWeight: 700,
    marginBottom: 20,
    color: "white",
  },
  heroSubtitle: {
    fontFamily: "var(--primary-font-semibold)",
    fontSize: 24,
    marginBottom: 20,
    color: "#e8f0ff",
  },
  heroDescription: {
    fontFamily: "var(--primary-font-medium)",
    fontSize: 18,
    lineHeight: 1.8,
    color: "#f0f6ff",
    maxWidth: "100%",
  },
  heroImageWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px 0",
  },
  heroImage: {
    maxHeight: 400,
    objectFit: "contain",
    borderRadius: 8,
  },
  highlight: {
    color: "#FFD700",
    fontWeight: 600,
  },


  // Features Section
  featuresSection: {
    paddingTop: 80,
    paddingBottom: 80,
    backgroundColor: "#f9fafb",
  },
  featureCard: {
    backgroundColor: "white",
    padding: 40,
    borderRadius: 12,
    textAlign: "center",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    transition: "all 0.3s ease",
    height: "100%",
    cursor: "pointer",
  },
  featureIconWrapper: {
    width: 70,
    height: 70,
    margin: "0 auto 24px",
    backgroundColor: "#f0f5ff",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  featureIcon: {
    color: "var(--primary-color)",
    fontSize: 36,
  },
  featureTitle: {
    fontFamily: "var(--primary-font-bold)",
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 12,
    color: "var(--heading-color)",
  },
  featureText: {
    fontFamily: "var(--primary-font-medium)",
    fontSize: 15,
    color: "var(--text-color)",
    lineHeight: 1.6,
  },


  // Offerings Section
  offeringsSection: {
    paddingTop: 80,
    paddingBottom: 80,
    backgroundColor: "white",
  },
  offeringCard: {
    padding: 30,
    backgroundColor: "#f9fafb",
    borderRadius: 8,
    borderLeft: "4px solid var(--primary-color)",
    height: "100%",
    transition: "all 0.3s ease",
  },
  offeringDot: {
    width: 12,
    height: 12,
    backgroundColor: "var(--primary-color)",
    borderRadius: "50%",
    marginBottom: 16,
    display: "inline-block",
  },
  offeringTitle: {
    fontFamily: "var(--primary-font-semibold)",
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 8,
    color: "var(--heading-color)",
  },
  offeringDescription: {
    fontFamily: "var(--primary-font-medium)",
    fontSize: 14,
    color: "var(--text-color)",
    lineHeight: 1.5,
    margin: 0,
  },


  // Values Section
  valuesSection: {
    paddingTop: 80,
    paddingBottom: 80,
    backgroundColor: "#f9fafb",
  },
  valueCard: {
    backgroundColor: "white",
    padding: 40,
    borderRadius: 12,
    textAlign: "center",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
    height: "100%",
  },
  valueIconWrapper: {
    width: 60,
    height: 60,
    margin: "0 auto 24px",
    backgroundColor: "#fff0f5",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  valueIcon: {
    color: "var(--primary-red)",
    fontSize: 28,
  },
  valueTitle: {
    fontFamily: "var(--primary-font-semibold)",
    fontSize: 18,
    fontWeight: 600,
    marginBottom: 12,
    color: "var(--heading-color)",
  },
  valueText: {
    fontFamily: "var(--primary-font-medium)",
    fontSize: 14,
    color: "var(--text-color)",
    lineHeight: 1.5,
    margin: 0,
  },


  // Future Services Section
  futureSection: {
    paddingTop: 80,
    paddingBottom: 80,
    backgroundColor: "white",
  },
  futureServiceItem: {
    padding: "16px 20px",
    backgroundColor: "#f5f8ff",
    borderRadius: 8,
    display: "flex",
    alignItems: "flex-start",
    gap: 12,
    border: "1px solid #e0e8f5",
    transition: "all 0.3s ease",
  },
  serviceBullet: {
    color: "var(--primary-color)",
    fontWeight: 700,
    fontSize: 18,
    minWidth: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  serviceText: {
    fontFamily: "var(--primary-font-medium)",
    fontSize: 14,
    color: "var(--text-color)",
    lineHeight: 1.5,
  },


  // Profit Section
  profitSection: {
    paddingTop: 80,
    paddingBottom: 80,
    backgroundColor: "#f9fafb",
  },
  profitCard: {
    backgroundColor: "#e8f1ff",
    borderRadius: 12,
    padding: 60,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: 300,
  },
  profitIconWrapper: {
    textAlign: "center",
  },
  profitIcon: {
    color: "var(--primary-color)",
    fontSize: 80,
    opacity: 0.8,
  },
  profitText: {
    fontFamily: "var(--primary-font-medium)",
    fontSize: 16,
    color: "var(--text-color)",
    lineHeight: 1.8,
    marginBottom: 20,
  },


  // CTA Section
  ctaSection: {
    paddingTop: 100,
    paddingBottom: 100,
    background: "linear-gradient(135deg, #075CF6 0%, #0645ca 100%)",
    color: "white",
    width: "90%",
    margin: "auto",
    marginTop: 50,
    marginBottom: 50,
    borderRadius: "40px"
  },
  ctaTitle: {
    fontFamily: "var(--primary-font-bold)",
    fontSize: 40,
    fontWeight: 700,
    marginBottom: 24,
    color: "white",
  },
  ctaText: {
    fontFamily: "var(--primary-font-medium)",
    fontSize: 18,
    lineHeight: 1.8,
    marginBottom: 20,
    color: "#f0f6ff",
    maxWidth: 800,
    margin: "0 auto 20px",
  },
  ctaClosing: {
    fontFamily: "var(--primary-font-medium)",
    fontSize: 16,
    lineHeight: 1.8,
    color: "#e8f0ff",
  },


  // Common Styles
  sectionTitle: {
    fontFamily: "var(--primary-font-bold)",
    fontSize: 36,
    fontWeight: 700,
    marginBottom: 12,
    color: "var(--heading-color)",
  },
  sectionTitleLeft: {
    fontFamily: "var(--primary-font-bold)",
    fontSize: 36,
    fontWeight: 700,
    marginBottom: 24,
    color: "var(--heading-color)",
  },
  sectionSubtitle: {
    fontFamily: "var(--primary-font-medium)",
    fontSize: 16,
    color: "var(--text-color)",
    lineHeight: 1.6,
  },


  // Legacy Styles for backward compatibility
  text: {
    fontFamily: "var(--primary-font-medium)",
    color: "var(--text-color)",
    fontSize: 16,
  },
  imgWrap: {
    width: 180,
    height: 180,
    overflow: "hidden",
    marginLeft: "auto",
    marginRight: "auto",
  },
  img: {
    height: "100%",
    width: "100%",
    objectFit: "contain",
  },
  contentWrap: {},
  title: {
    fontFamily: "var(--primary-font-semibold)",
    color: "var(--heading-color)",
    fontSize: 20,
  },
  info: {
    fontFamily: "var(--primary-font-medium)",
    color: "var(--text-color)",
    fontSize: 16,
  },
  careerImgWrap: {
    width: 350,
    height: 244,
    overflow: "hidden",
    marginLeft: "auto",
    marginRight: "auto",
  },
  subTitle: {
    fontFamily: "var(--primary-font-medium)",
    color: "var(--text-color)",
    fontSize: 12,
  },
  sectionContainer: {
    paddingTop: 100,
    paddingBottom: 100,
  },
  paragraph: {
    fontFamily: "var(--primary-font-medium)",
    color: "var(--text-color)",
    fontSize: 16,
    marginBottom: 20,
    lineHeight: 1.6,
  },
  listItem: {
    fontFamily: "var(--primary-font-medium)",
    color: "var(--text-color)",
    fontSize: 16,
    marginBottom: 10,
    lineHeight: 1.6,
  },
  boldText: {
    fontWeight: 600,
  },
};


export default styles;





